import { Model } from '@vuex-orm/core'
import { Lesson, Substitution } from 'src/store/models/timetable/index.js'
import { UnitsFrom, UnitsTo } from 'src/store/models/pivot/index.js'

export class Unit extends Model {
  static entity = 'unit'

  static fields () {
    return {
      id: this.attr(null),
      lesson_id: this.attr(null),
      lesson: this.belongsTo(Lesson, 'lesson_id'),
      week: this.number(0),
      weekday: this.number(0),
      begins_at: this.attr(null),
      ends_at: this.attr(null),
      deleted_at: this.attr(null),
      substitutions_from_pivot: this.hasMany(UnitsTo, 'unit_id'),
      substitutions_from: this.belongsToMany(Substitution, UnitsTo, 'unit_id', 'substitution_id'),
      substitutions_to_pivot: this.hasMany(UnitsFrom, 'unit_id'),
      substitutions_to: this.belongsToMany(Substitution, UnitsFrom, 'unit_id', 'substitution_id')
    }
  }
}

export default Unit
